(function($){
  // set everything outside the onscroll event (less work per scroll)
  var nav      = document.getElementById("nav-main"),
      stop      = nav.offsetTop,
      docBody   = document.documentElement || document.body.parentNode || document.body,
      hasOffset = window.scrollY !== undefined,
      scrollTop;

  window.onscroll = function (e) {
    // cross-browser compatible scrollTop.
    stop      = nav.offsetTop;
    scrollTop = hasOffset ? window.scrollY : docBody.scrollTop;

    // if user scrolls to 60px from the top of the left div
    if (scrollTop >= stop) {
      // stick the div
      $(nav).addClass('stick');
    } else {
      // release the div
      $(nav).removeClass('stick');
    }
  }
})(jQuery);